export enum AccessLevelSetting {
  normal = 0x00,
  advanced = 0x71,
  full = 0x81,
  manufacturer = 0x92,
}
